import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'
import Typography from 'components/Typography'

import classes from './NoSnippets.module.scss'

const NoSnippets = () => {
  return (
    <div className={clsx('NoSnippets', classes.root)}>
      <Icon className={classes.icon} icon="circle-info" prefix="far" size={24} />
      <Typography className={classes.typography} variant="body-xs">
        <span>Not enough</span>
        <span className={classes.spanReviewsYet}>reviews yet</span>
      </Typography>
    </div>
  )
}

export default NoSnippets
